import React, { useContext, useEffect, useState } from "react";

import {
  Container,
  Row,
  Col,
  Form,
  InputGroup,
  Button,
} from "react-bootstrap";
import {
  FaSearch,
  FaFilter,
  FaBolt,
  FaFire,
  FaChartLine,
} from "react-icons/fa";


import AllDealsCard from "../../../components/user/card/allDealsCard/TpDealCard";

import Navbar from "../../../components/user/navbar/Navbar";
import Footer from "../../../components/user/footer/Footer";
import SimpleBanner from "../../../components/user/general/SimpleBanner";
// import AllDealsCard from "../../../components/user/card/allDealsCard/AllDealsCard";
import AppContext from "../../../context/AppContext";
import axios from "axios";

import "../../../assets/css/user/deals/allDeals.css";
import MarqueeBanner from "../../../components/user/Marqueebanner/Marqueebanner";
import MyNavbar from "../../../components/user/navbar/Navbar";

const categories = [
  { name: "Health & Wellness", count: 45 },
  { name: "Beauty & Spa", count: 38 },
  { name: "Auto & Home", count: 27 },
  { name: "Family & Kids", count: 32 },
  { name: "Food & Drink", count: 51 },
  { name: "Travel", count: 19 },
  { name: "Education", count: 23 },
  { name: "Fitness", count: 29 },
];

const AllDeals = () => {
  const {
    baseUrl,
    selectedCategory,
    selectedCategoryTagline,
  } = useContext(AppContext);

  const [tpdeals, setTpdeals] = useState([]);

  const viewAllDeals = () => {
    axios
      .post(`${baseUrl}/customer/deals/viewAllDeals`)
      .then((response) => {
        setTpdeals(response.data.deals);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    viewAllDeals();
  }, []);

  return (
    <>
    <MarqueeBanner />
      <MyNavbar />

      <Container fluid>
        <SimpleBanner
          title={selectedCategory}
          subtitle={selectedCategoryTagline}
          breadcrumbs={[
            { label: "Home", href: "/" },
            { label: "Deals", href: "/all-deals" },
            { label: "Deal Details", current: true },
          ]}
        />

        <Container className="allDeals-wrapper">

          <h2 className="fw-bold mb-1">All Deals</h2>

          <p className="text-muted mb-4">
            Discover amazing deals from verified sellers
          </p>

          {/* Search + Filters */}
          <Row className="align-items-center g-3 mb-4">
            <Col lg={8}>
              <InputGroup>
                <InputGroup.Text className="search-icon">
                  <FaSearch />
                </InputGroup.Text>

                <Form.Control
                  placeholder="Search deals..."
                  className="search-input"
                />
              </InputGroup>
            </Col>

            <Col lg={4}>
              <div className="filter-buttons">
                <Button className="filter-btn active-btn">
                  <FaFilter className="me-2" />
                  All
                </Button>

                <Button className="filter-btn">
                  <FaBolt className="me-2" />
                  Instant
                </Button>

                <Button className="filter-btn">
                  <FaFire className="me-2" />
                  Hot
                </Button>

                <Button className="filter-btn">
                  <FaChartLine className="me-2" />
                  Trending
                </Button>
              </div>
            </Col>
          </Row>

          {/* Categories */}

          <div className="category-list mb-5">
            {categories.map((item, index) => (
              <button
                key={index}
                className={`category-chip ${
                  item.name === "Fitness" ? "selected-chip" : ""
                }`}
              >
                {item.name} ({item.count})
              </button>
            ))}
          </div>

          {/* Cards */}

          <Row>
            <AllDealsCard deals={tpdeals} />
          </Row>

        </Container>
      </Container>

      <Footer />
    </>
  );
};

export default AllDeals;